$(function(){
  // -------------------
  // SHOPIFY INIT
  // -------------------

  initShopify();

  // -------------------
  // Shopify-scoped local functions
  // -------------------
  
  cartTog.removeClass('active');
  checkProducts();

});

var $cartClose;

var $cart = {
  "popup":false,
  "startOpen":true,
  "iframe":false,
  "text": {
    "title": "Your Basket",
    "total": "Subtotal",
    "button": "Checkout"
  },
  "events":{
    updateItemQuantity: function(cart){
      checkProducts()
      setTimeout(function(){
        if(cart.lineItemCache.length < 1){
          cartTog.click()
        }
      },1000);
    },
    afterRender: function(component){
      checkProducts();
      cartCloseButton();
      var checkoutLS = shopifyToken + '.' + shopifyDomain + '.checkoutId';
      var checkoutId = localStorage.getItem(checkoutLS);
      console.log("Cart Rendered > CheckOutId", checkoutId);

      if(checkoutId != null)
      {
        $("[name='CheckoutId']").val(checkoutId);
      }

      console.log(component)

    }
  },
  "styles":{
    "wrapper":{
      "display":"none"
    }
  }
},
$toggle = {
  "sticky":false,
  "iframe":false,
  "styles": {
    "toggle": {
      "background-color": "#000000",
      ":hover": {
        "background-color": "#000000"
      },
      ":focus": {
        "background-color": "#000000"
      }
    }
  }
};

function initShopify(){
  var scriptURL = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit();
    } else {
      loadScript();
    }
  } else {
    loadScript();
  }
  function loadScript() {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
    script.onload = ShopifyBuyInit;
  }
  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: shopifyDomain,
      storefrontAccessToken: shopifyToken,
    });
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      

       if ($('.shopifyproductbutton').length) {

                $('.shopifyproductbutton').each(function () {

                    var elId = $(this).attr('id');
                    var shopProdId = $(this).attr('data-product');
                    var ageVerification = $(this).attr('data-age-verification');
                    var qtyLimit = $(this).attr('data-product-limit') || false;

                    shopifyProduct(ui, elId, shopProdId, ageVerification, qtyLimit);
                });

                shopifyProduct(
                    ui,
                    $('#add-to-basket-single').attr('data-product'),
                    $('#add-to-basket-single').attr('data-age-verification')
                );

            } else {
                shopifyCart(ui);
            }

        // REMOVE CONFLICTING SHOPIFY DEFAULT STYLES
        $('head').find('style').remove();
      });
  }
}

var hasAgeWarning = false;

function checkProducts(){
  var products = $('.shopify-buy__cart-item');
  if(products.length > 0){
    cartTog.addClass('active');
  } else{
    cartTog.removeClass('active');
  }
  if(hasAgeWarning && !$('.shopify-cart-gatekeeper').length){
    var $ageWarning = $('<span>',{
      class:'shopify-cart-gatekeeper'
    });
    $ageWarning.text("You've added an age restricted item. Age verification may be requested on delivery.");
   $('.shopify-buy__cart__header').after($ageWarning);
  }
  cartContinueButton()

  // Check for QTY Limiting
  products.each(function(){
    var uniqueTitle = cleanTitle($(this).find('.shopify-buy__cart-item__title').text());
    var maxQty = localStorage.getItem(uniqueTitle);
    if(maxQty != null){
      var $qty = $(this).find('.shopify-buy__quantity.shopify-buy__cart-item__quantity-input');
      $qty.attr('max',maxQty);
      if($qty.val() > maxQty){
        $qty.focus().val(maxQty).blur();
        $(this).find('.shopify-buy__quantity-increment').remove();
      }
    }
  })
}

var cartClose = false;

function cartCloseButton(){
  if(!cartClose){
    cartClose = $('<button>',{class:'shopify-cart-close-btn'});
    $('.shopify-buy-cart-wrapper').append(cartClose);
    cartClose.click(function(){
      cartTog.click();
    });
  }
}

function cartContinueButton(){
  if(!$('.shopify-cart-continue-btn').length){
    cartContinue = $('<button>',{class:'shopify-cart-continue-btn'});
    $('.shopify-buy__cart-bottom').append(cartContinue);
    cartContinue.text('Continue Shopping');
    cartContinue.click(function(){
      cartTog.click();
    });
  }
}

function cleanTitle(string){
  return string.replace(/[^\w]/gi, '').toLowerCase();
}

function shopifyProduct(ui, elId, productID,isAgeVerified,qtyLimit){
  var productUniqueTitle; // Used for qty limiting
  var $product = ui.createComponent('product', {
    id: productID,
    node: document.getElementById(elId),
    moneyFormat: '%C2%A3%7B%7Bamount%7D%7D',
    // toggles: [{node: document.getElementById('basket-toggle')}],
    customAttributes:[
      {
       "key":productID,
       "value":qtyLimit 
      }
    ],
    options: {
      "product": {
        "iframe":false,
        "contents": {
          "img": false,
          "button": false,
          "buttonWithQuantity": true,
          "title": true,  // Hidden w/ css but required for qty checking
          "price": false
        },
        "text": {
          "button": "Add to cart"
        },
        "events":{
          afterRender: function (component) {
            // Limit QTY if applicable
            if(qtyLimit){
              var el = $('.shopifyproductbutton[data-product='+component.id+']');
              el.find('.shopify-buy__quantity').attr('max',qtyLimit);
              productUniqueTitle = cleanTitle(el.find('.shopify-buy__product__title').text());
            }
          },
         addVariantToCart: function (product) {
          if(isAgeVerified.toLowerCase() == 'true'){
            hasAgeWarning = true;
          }
          if(qtyLimit){
            localStorage.setItem(productUniqueTitle, qtyLimit);
          }
          $('#basket-toggle').trigger('click');
          checkProducts();
         },
       }
     },
     "cart": $cart,
     "toggle": $toggle
  }
});

}

function shopifyCart(ui){
  ui.createComponent('cart', {
    moneyFormat: '%C2%A3%7B%7Bamount%7D%7D',
    // toggles: [{node: document.getElementById('basket-toggle')}],
    options: {
      "cart": $cart,
      "toggle": $toggle,
      "events":{
        afterRender: function () {
          alert()
        },
      },
    },
  });
}